import { render, staticRenderFns } from "./double11.vue?vue&type=template&id=424e9241&scoped=true&"
import script from "./double11.vue?vue&type=script&lang=js&"
export * from "./double11.vue?vue&type=script&lang=js&"
import style0 from "./double11.vue?vue&type=style&index=0&id=424e9241&lang=less&scoped=true&"
import style1 from "./double11.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e9241",
  null
  
)

export default component.exports